import { useEffect, useState } from 'react'

/**
 * Detects whether Tailwind's `dark` mode class is applied on the root element.
 * Useful for integrating third-party widgets that rely on explicit theme tokens.
 */
export const useTailwindDarkMode = () => {
	const [isDarkMode, setIsDarkMode] = useState(false)

	useEffect(() => {
		if (typeof document === 'undefined') {
			return
		}

		const rootElement = document.documentElement
		const updateThemeState = () => {
			setIsDarkMode(rootElement.classList.contains('dark'))
		}

		updateThemeState()

		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				if (
					mutation.type === 'attributes' &&
					mutation.attributeName === 'class'
				) {
					updateThemeState()
					break
				}
			}
		})

		observer.observe(rootElement, {
			attributes: true,
			attributeFilter: ['class'],
		})

		return () => observer.disconnect()
	}, [])

	return isDarkMode
}
